import { render, staticRenderFns } from "./ViewTabs.vue?vue&type=template&id=f87a0d9e&"
import script from "./ViewTabs.vue?vue&type=script&lang=js&"
export * from "./ViewTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewTabs.vue"
export default component.exports